import apiClient from '@/services/api'

export default {
    namespaced: true,
    state: {
        settings: {
            general: { site_name: 'EM CONTRACTING CORP', site_tagline: '' },
            contact: { contact_email: '', contact_phone: '', contact_address: '' },
            social: { 
                social_facebook: '', 
                social_instagram: '', 
                social_tiktok: '', 
                social_whatsapp: '',
                social_linkedin: '',
                social_youtube: '',
                social_x: ''
            },
            stats: {
                stats_years_experience: '10+',
                stats_projects_completed: '150+',
                stats_value_delivered: '$5M+',
                stats_safety_commitment: '100%'
            }
        },
        loading: false
    },
    mutations: {
        SET_SETTINGS(state, settings) {
            state.settings = { ...state.settings, ...settings }
        },
        SET_LOADING(state, loading) {
            state.loading = loading
        }
    },
    actions: {
        async fetchSettings({ commit }) {
            commit('SET_LOADING', true)
            try {
                const { data } = await apiClient.get('/settings')
                commit('SET_SETTINGS', data)
            } catch (error) {
                console.error('Error fetching site settings:', error)
            } finally {
                commit('SET_LOADING', false)
            }
        }
    },
    getters: {
        allSettings: state => state.settings,
        contactInfo: state => state.settings.contact,
        socialLinks: state => state.settings.social,
        siteInfo: state => state.settings.general,
        stats: state => state.settings.stats
    }
}
